<template>
	<c-dialog ref="dialog" width="800" height="600" enable-flex button-name="保存" :cancel-button="false" @resolve="saveHandle" @close="templateContent = ''">
		<c-form ref="form" column="2" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-column class="flex-grow">
				<c-form-item label="模板名称" required>
					<c-input name="name"></c-input>
				</c-form-item>
				<c-form-item label="纸张大小" required>
					<div class="flex" style="gap: 10px;">
						<c-select v-model="currentPaperSize" name="paper" :options="paperSize" :clear="false" @change="paperHandle"></c-select>
						<div v-show="currentPaperSize == 'auto'" class="flex-center" style="min-width: 60%; gap: 5px;">
							<c-input type="number" :range="[10,1000]" name="width" placeholder="宽度" append-text="mm" :clear="false" @change="sizeHandle('width', $event)"></c-input>
							<span>×</span>
							<c-input type="number" :range="[10,1000]" name="height" placeholder="长度" append-text="mm" :clear="false" @change="sizeHandle('height', $event)"></c-input>
						</div>
					</div>
				</c-form-item>
			</c-form-column>
			<c-form-column style="width: 300px;">
				<c-form-item label="模板边距">
					<c-radio-group name="padding" @change="paddingHandle">
						<c-radio value="1">有边距</c-radio>
						<c-radio value="0">无边距</c-radio>
					</c-radio-group>
				</c-form-item>
				<c-form-item label="显示边框">
					<c-radio-group name="border" @change="borderHandle">
						<c-radio value="1">显示</c-radio>
						<c-radio value="0">不显示</c-radio>
					</c-radio-group>
				</c-form-item>
			</c-form-column>
		</c-form>
		
		<div ref="template" class="c-template flex-grow">
			<jodit-editor :value="templateContent" :config="config" :buttons="buttons" />
			
			<div class="field-list" :class="{'z-active': insertType == 'text'}">
				<p>插入文本</p>
				<ul class="flex-column">
					<li v-for="(item, i) in fieldList" :key="i" v-text="`{{${item}}}`" @click="insertHandle(item)"></li>
				</ul>
			</div>

			<div class="field-list" :class="{'z-active': insertType == 'qrcode'}">
				<p>插入二维码</p>
				<ul class="flex-column">
					<li v-for="(item, i) in fieldList" :key="i" v-text="`{{qc ${item}}}`" @click="insertHandle(item, 'qc')"></li>
				</ul>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	import {JoditEditor} from 'jodit-vue'

	const defaultTemplate = '<div class="print-page" border="1" style="padding: 3mm;"></div>';
	const qrcode = 'data:image/png;base64,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';

	export default {
		name: 'printTemplateEdit',
		
		components: {
			JoditEditor
		},

		data() {
			return {
				paperSize: [{
					name: '30mm x 55mm',
					value: '30x55'
				}, {
					name: '70mm x 50mm',
					value: '70x50'
				}, {
					name: '80mm x 60mm',
					value: '80x60'
				}, {
					name: '80mm x 100mm',
					value: '80x100'
				}, {
					name: '自定义',
					value: 'auto'
				}],
				currentPaperSize: '',

				buttons: ['table', {
					name: 'field',
					tooltip: '插入文本',
					iconURL: require('@/assets/image/field.svg'),
					exec: editor => {
						this.insertType = 'text';
						this._insertHandle = str => {
							editor.selection.insertHTML(str);
						}
					}
				}, {
					name: 'qrcode',
					tooltip: '插入二维码',
					iconURL: require('@/assets/image/qrcode.svg'),
					exec: editor => {
						this.insertType = 'qrcode';
						this._insertHandle = str => {
							editor.selection.insertHTML(str);
						}
					}
				}, {
					name: 'preview',
					tooltip: '打印预览',
					iconURL: require('@/assets/image/preview.svg'),
					exec: editor => {
						this.templatePreview(this.$refs.template.querySelector('.templete-content').innerHTML)
					}
				}, '|', 'fontsize', 'bold', 'italic', 'underline', 'strikethrough', 'eraser', 'superscript', 'subscript', '|', 'left', 'center', 'right', 'lineHeight'],
				config: {
					height: '100%',
					language: 'zh_cn',
					defaultFontSizePoints: 'pt',
					allowResizeY: false,
					useSearch: false,
					showCharsCounter: false,
					showWordsCounter: false,
					showXPathInStatusbar: false
				},
				fieldList: [],
				insertType: '',
				templateContent: ''
			}
		},
		
		methods: {
			open(data = {}) {
				this._editState = !data.copy && !!data.id;
				this._workType = data.workType;
				this.insertType = '';
				this.$refs.form.clear();
				var template_name = '';
				if (data.template_name){
					if (data.copy){
						template_name = data.template_name + '-复制';
					}else {
						template_name = data.template_name;
					}
				}
				this.$refs.form.set(Object.assign({
					id: data.copy ? undefined : data.id,
					name: template_name,
					paper: this.paperSize[0].value,
					padding: 1,
					border: 1
				}, JSON.parse(data.template_config || '{}')));

				this.templateContent = `<div class="templete-content">${data.template_content || defaultTemplate}</div>`.replace(/{{qc ([^\s]+) ([\.\d]+)x([\.\d]+)}}/gi, (...data) => {
					return `<img title="{{qc ${data[1]}}}" src="${qrcode}" width="${parseInt(this.mm2px(data[2]))}" height="${parseInt(this.mm2px(data[3]))}">`;
				});
				this.$refs.dialog.open({
					title: data.copy ? '复制打印模板' : data.id ? '编辑打印模板' : '新增打印模板'
				});
				this.$nextTick(() => {
					this.paperHandle({
						value: this.currentPaperSize
					});
					let paperSize = this.paperSize.find(item => item.value == this.currentPaperSize);
					this.currentPaperSize = paperSize ? paperSize.value : 'auto'
				});

				this.request({
					url: '/print/field',
					data: {
						work_type: this._workType
					},
					success: data => {
						this.fieldList = data.concat(['系统时间']);
					}
				})
			},

			insertHandle(field, event = '') {
				field = `{{${event}${event ? ' ' : ''}${field}}}`;
				if (event == 'qc') {
					this._insertHandle(`<img title="${field}" src="${qrcode}" width="100" height="100">`);
				} else {
					this._insertHandle(field);
				}
			},

			paperHandle({value}) {
				if (value && value != 'auto') {
					let [width, height] = value.split('x');
					this.$refs.form.set({
						width,
						height
					});
					this.sizeHandle('width', width);
					this.sizeHandle('height', height);
				}
			},

			sizeHandle(type, value) {
				if (value) {
					this[`_last_${type}`] = value;
					this.$refs.template.querySelector('.print-page').style[type] = value + 'mm';
				} else {
					this.$refs.form.set({
						[type]: this[`_last_${type}`]
					});
				}
			},

			paddingHandle(data) {
				this.$refs.template.querySelector('.print-page').style.padding = data == 1 ? '3mm' : '0';
			},

			borderHandle(data) {
				this.$refs.template.querySelector('.print-page').setAttribute('border', data);
			},

			saveHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: this._editState ? '/export/template/html/edit' : '/export/template/add',
					rule: {
						name: '请填写模板名称'
					},
					dataFormatter: data => {
						return {
							template_type: 1,
							work_type: this._workType,
							id: data.id,
							template_name: data.name,
							template_content: this.parseTemplateEdit(this.$refs.template.querySelector('.templete-content').innerHTML),
							template_config: JSON.stringify({
								paper: data.paper == 'auto' ? `${data.width}x${data.height}` : data.paper,
								padding: data.padding,
								border: data.border
							})
						};
					},
					success: () => {
						this.$message({
							message: '保存成功'
						});
						next();
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-template {
		position: relative;
		border-top: 1px solid #dadada;
		overflow: hidden;

		.field-list {
			z-index: 98;
			position: absolute;
			top: 39px;
			right: 0;
			bottom: 0;
			border-left: 1px solid #dadada;
			overflow: auto;
			background: #fff;
			transform: translate(100%, 0);
			transition: transform .5s ease;
			
			&.z-active {
				z-index: 99;
				transform: translate(0, 0);
			}

			p {
				position: sticky;
				top: 0;
				line-height: 36px;
				text-align: center;
				background: #fff;
			}

			ul {
				padding: 10px;
				margin-left: -5px;
				margin-top: -5px;
			}
			
			li {
				align-self: flex-start;
				border-radius: 3px;
				padding: 0 7px;
				line-height: 22px;
				font-size: 13px;
				color: #333;
				background: #F5F5F5;
				margin-left: 5px;
				margin-top: 5px;
				cursor: pointer;

				&:hover {
					color: #fff;
					background: var(--color-main);
				}
			}
		}
	}

	>>> .jodit-wysiwyg {
		font-size: 10pt;
		background: #F8F8F8;

		.print-page {
			overflow: hidden;
			background: #fff;

			table {
				max-width: 100%;
				margin: 0;

				td {
					vertical-align: middle;
					padding: 0 1.5mm;
					word-break: break-all;
					
					img {
						vertical-align: middle;
					}
				}
			}
		}
	}

	>>> .jodit-container:not(.jodit_inline) {
		border: none;
	}

	>>> .jodit-add-new-line,
	>>> .jodit-placeholder {
		display: none !important;
	}

	>>> .jodit-toolbar-button .jodit-icon {
		width: 16px;
		height: 16px;
	}
</style>